import type { IconSource } from '@shopify/polaris';

import { AdjustIcon, ChartVerticalFilledIcon, GaugeIcon } from '@shopify/polaris-icons';

/** FAQ tab identifiers — domain value set (No10). */
export const FAQ_TAB = {
  TestSetup: 'test-setup',
  Performance: 'performance',
  DataAccuracy: 'data-accuracy',
} as const;

export type IFaqTabId = (typeof FAQ_TAB)[keyof typeof FAQ_TAB];

/** Tab opened from the dashboard "FAQ" card (top of the list). */
export const FAQ_DEFAULT_TAB: IFaqTabId = FAQ_TAB.TestSetup;

/** Tab opened from every "FAQ about data numbers" entry across the analytics screens. */
export const FAQ_DATA_NUMBERS_TAB: IFaqTabId = FAQ_TAB.DataAccuracy;

export const FAQ_TAB_ICON: Record<IFaqTabId, IconSource> = {
  [FAQ_TAB.TestSetup]: AdjustIcon,
  [FAQ_TAB.Performance]: GaugeIcon,
  [FAQ_TAB.DataAccuracy]: ChartVerticalFilledIcon,
};

/**
 * Help-article URLs for FAQ answers that link out via a "Learn more" link.
 * An empty value renders no link, so the entry stays dormant until a URL is set.
 */
export const FAQ_LEARN_MORE_URL = {
  testDuration: 'https://gemx.net/blogs/help-center/experiment-duration',
  trafficSplitting: 'https://gemx.net/blogs/help-center/how-traffic-splitting-work-in-gemx',
  statisticalSignificance: 'https://gemx.net/blogs/help-center/gemx-probability-to-win',
  dataDelay: 'https://gemx.net/blogs/help-center/tracking-data-delayed-in-gemx',
} as const;
